import { z } from "zod";
import { isValidTimeZone } from "../../utils/is-valid-time-zone.js";
import { emailSchema } from "../common/index.js";
import { MeetingAudience, MeetingFormat, MeetingVisibility } from "../enum.js";

export const updateMeetingSchema = z
	.object({
		title: z.string().min(2).max(200).optional(),
		description: z.string().max(10000).nullable().optional(),
		cover_image: z.url().nullable().optional(),
		format: z.enum(MeetingFormat).optional(),
		start_at: z.iso.datetime().optional(),
		end_at: z.iso.datetime().optional(),
		timezone: z.string().min(1).max(100).refine(isValidTimeZone, { message: "Invalid timezone" }).optional(),
		address: z.string().max(500).nullable().optional(),
		latitude: z.number().min(-90).max(90).nullable().optional(),
		longitude: z.number().min(-180).max(180).nullable().optional(),
		max_capacity: z.number().int().min(1).nullable().optional(),
		audience: z.enum(MeetingAudience).optional(),
		group_ids: z.array(z.string().uuid()).optional(),
		member_ids: z.array(z.string().uuid()).optional(),
		visibility: z.enum(MeetingVisibility).optional(),
		external_emails: z.array(emailSchema).max(50).optional(),
	})
	.strict();

export type UpdateMeetingPayload = z.infer<typeof updateMeetingSchema>;
